export default __webpack_public_path__ + "static/media/Mask_group.3a2b6df7.png";